import { proxyBE } from "./common";

export const quizService = {
  saveAttempt(data) {
    const quiz = { ...data.params };
    return proxyBE.post("userQuiz/saveAttempt", { quiz });
  },
};
